import { app } from '../../../../app';
import { Controller } from './license-tier-details.controller';

app.component('licenseManagementTierDetails', {
    bindings: {close: '&', dismiss: '&', resolve: '<'},
    controller: Controller,
    templateUrl: require('./license-tier-details.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/license-management/tier-details/license-tier-details.component.js